import { MessageCircle } from "lucide-react";
import { BRAND } from "../data/site";

export default function FloatingWhatsApp() {
    const href = `https://wa.me/${BRAND.leadWhatsapp}?text=${encodeURIComponent(
        "Hello RP Traders, I'd like to enquire about your export products."
    )}`;
    return (
        <a
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="floating-whatsapp"
            className="group fixed bottom-5 left-5 z-40 inline-flex items-center gap-2 rounded-full bg-[#25D366] py-3 pl-3 pr-4 text-sm font-semibold text-white shadow-xl shadow-emerald-700/25 transition-transform hover:scale-105"
            aria-label="Chat with Export Team on WhatsApp"
        >
            <span className="grid h-7 w-7 place-items-center rounded-full bg-white/15">
                <MessageCircle className="h-4 w-4" />
            </span>
            <span className="hidden sm:inline">Chat with Export Team</span>
            <span className="sm:hidden">WhatsApp</span>
            <span className="absolute -right-0.5 -top-0.5 h-3 w-3 animate-ping rounded-full bg-emerald-400" />
            <span className="absolute -right-0.5 -top-0.5 h-3 w-3 rounded-full bg-emerald-500" />
        </a>
    );
}
